<script>
  import Menu from './Menu';

  export default {
    // mixins: [closeMixin],
    name: 'SearchPredictive',
    components:{
      Menu
    },
    props: ['borderRadius', 'placeholder','backgroundColor', 'fontSize', 'arraySearch'],
    data(){
      return {
        isOpen: false,
        keywords: "",
      }
    },
    mounted(){
      // console.log(document.getElementById('menu' + this.width))
      // // Que la modale récupère le focus au démarrage pour que l'évènement 'ESC' soit capté.
      // // document.getElementById("menu").focus() //ça fout une bordure dégueulasse....
      // for (const item of document.getElementById('menu' + this.width).childNodes) {
      //   item.style.width = this.width
      // }

      //Dans le cas où j'ai un border radius sur le conteneur dans le parent, je met le même radius sur le ou les inputs
      //Je met aussi la couleur voulu en arrière plan
      for (let item of document.getElementsByClassName('search-input')){
        item.style.borderRadius = this.borderRadius
        item.style.backgroundColor = this.backgroundColor
        item.style.fontSize = this.fontSize
      }
    },
    methods: {
      search(str){
        const regExp = new RegExp(str,"gi");
        const check = obj => {
          if (obj !== null && typeof obj === "object") { return Object.values(obj).some(check) }
          if (Array.isArray(obj)) { return obj.some(check) }
          return (typeof obj === "string" || typeof obj === "number") && regExp.test(obj);
        }
        return this.arraySearch.filter(check)
      },
      valid(str){
        if(str == ""){
          this.$emit('result', 'all')
        } else {
          this.$emit('result', this.search(str))
        }

        this.keywords = "";
        document.activeElement.blur();
        this.isOpen = false;
      },
      selectOne(item){
        this.$emit('result', [item])
        this.isOpen = false
      }
    },
  };
</script>

<template>
  <div class="search">
    <input class="search-input" type="search" :placeholder="placeholder" @focus="isOpen = true" @keyup.enter="valid(keywords)" v-model="keywords" @click="isOpen = true">
    <!-- <span class="material-icons search-icon">search</span> -->
    <Menu class="search-menu" v-if="isOpen && keywords"  @close="isOpen = false">
      <template v-slot:body>
        <div v-for="item in search(keywords).slice(0, 5)" :key="item._id" :style="'font-size:' + fontSize + ';'" class="search-menu-result" @click="selectOne(item)">
          {{item.stringLine}}
        </div>
      </template>
    </Menu>
  </div>
</template>

<style lang="scss">
@import '../assets/main.scss';

.search{
  // width: 100%; // à gérer dans le parent sinon dans contact ça décalle le serach (le border le fait sortir du grid de 2px)
  position: relative;

  &-input{
    background-color: $black-lighter; //Couleur par défaut si rien n'est spécifié
    padding: 0 10px;
    width: 100%;
    height: 100%;
    border: none;
    color: $black-bolder;
  }

  // &-icon{
  //   position: absolute;
  //   right: 0;
  //   top: 1px;
  // }

  &-menu{
    width: 100%;
    margin: 7px 0 0 0;
    z-index: 1000;

    &-result{
      @include myFont;
      font-size: 13px;
    }
  }
}

</style>
